import React from 'react';
import { Carousel } from 'lunchbox';
import StarsRating from '../StarsRating';
import { CUSTOMER_REVIEW_CONSTANT } from '../../data/constant';

const CustomerReview = () => {
  const renderPromoSlides = (slides) =>
    slides.map((slide, index) =>
      (
        <div
          className="slide slide__item flex flex-col"
          id={`slide-review-${index + 1}`}
          key={`slide_review_${slide.author}`}
        >
          <div className="flex p-4 sidebar-testimony__item-description">
            <span className="text-3xl absolute text-lp-gray-10 quote top-4 left-4">“</span>
            <div className="text-xs font-normal text-lp-gray-10 mb-2 whitespace-normal rounded-lg text-left pl-6 slide__content">
              {slide.content}
              <div className="text-xs font-bold mt-2 sidebar-testimony__item-author">
                {slide.author}
              </div>
            </div>
          </div>
        </div>
      ));

  return (
    <div className="customer__review--wrapper shadow-lg md-max:mx-2.5">
      <div className="slide__header">
        <div className="text-lp-dark-gunmetal CustomerReview_companyInfo__header">
          <div className="font-semibold text-sm mb-2 ">16000+ Pelanggan Puas dengan Lifepal</div>
          <div className="text-lp-black">Lifepal </div>
          <StarsRating rating={4.9} totalReview={1534} />
        </div>
      </div>
      <Carousel
        totalSlides={CUSTOMER_REVIEW_CONSTANT.length}
        visibleSlides={1}
        slides={CUSTOMER_REVIEW_CONSTANT}
        renderSlides={renderPromoSlides}
        showDotGroup
        shouldPlay
        isInfinite
        className="customer__review--container"
        interval={5000}
      />
    </div>
  );
};

export default CustomerReview;
